// extracted by mini-css-extract-plugin
export default {"input":"_3bHsLBiPHcn56LHMqkPKIk"};